import Hero from "@components/organisms/common/Hero";
import CutoutFeaturedImage from "@components/organisms/common/CutoutFeaturedImage";
import Theme from "@components/Theme";
import Masonry from "@components/organisms/common/Masonry";
import FeaturedImage from "@components/organisms/common/FeaturedImage";
import People from "@components/organisms/common/People";
import WideCTA from "@components/organisms/common/WideCTA";
import BoxShadowCard from "@components/organisms/common/BoxShadowCard";
import Schema from "@components/organisms/common/Schema";
import AppStorage from "@components/AppStorage";
import TpWidget from "@components/atoms/document/TpWidget";
import GetProFreePlan from "@components/organisms/common/GetProFreePlan";

export async function getStaticProps(ctx) {
  const { locale } = ctx;
  let allData = {};

  // Page Route
  const route = "eliminate-fake-appointments";

  // Fetch
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );

  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );
  const pricingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/pricing.json`
  );

  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/marketing.json`
  );

  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/content.json`
  );

  // Catch Error
  if (
    !headerResponse.ok ||
    !footerResponse.ok ||
    !marketingResponse.ok ||
    !contentResponse.ok
  ) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.pricing = await pricingResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };
  const pricing = {
    pricing: allData.pricing,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...pricing,
    ...allData.marketing,
    ...allData.content,
  };

  return {
    props: {
      data,
      locale,
    },
  };
}

export default function Page({ data, locale }) {
  const { seo, header, footer, pricing, content } = data;
  const FAQs = () => {
    return (
      <section className="faq-section lg:pb-10 bg-offset-bottom">
        <article className="container lg:maxw-lg text-center mx-auto md:mb-5">
          <h2
            className="text-xl lg:mb-10"
            dangerouslySetInnerHTML={{ __html: content.faqs.title }}
          />
        </article>
        <BoxShadowCard data={content.faqs.list} colCount="2" />
      </section>
    );
  };
  return (
    <Theme
      header={header}
      footer={footer}
      seo={seo}
      className="pricing-layout land-pages"
    >
      <AppStorage pageName="Others - eliminate-fake-appointments" />
      <Hero data={content.hero} />
      <CutoutFeaturedImage
        data={content.cutoutFeaturedImage}
        className="lg:pb-10 md:pb-7"
      />
      <Masonry
        data={content.masonry}
        className="lg:mb-20 md:mb-10 bg-offset-top"
      />
      <section>
        {content.featuredImageSections.map((item, index) => {
          return (
            <FeaturedImage
              data={item}
              key={index}
              imageAlign={item.image.align}
            />
          );
        })}
      </section>
      <FAQs />
      {pricing.pricingPlanContent ? (
        <section className="bg-light">
          <GetProFreePlan
            content={pricing.pricingPlanContent}
            pricing={pricing}
            initialPlanType="annual-billing-plan"
            className="pricing-wrap"
          />
        </section>
      ) : null}
      <People className="bg-light" />
      <WideCTA data={content.wideCTA} />
      {content.hasOwnProperty("faqs") && <Schema data={content.faqs.list} />}
      <TpWidget />
    </Theme>
  );
}
